/**
 * Disable Highway.js SPA navigation store-wide.
 *
 * Goal: every in-site link is a real document load so Shoplift can evaluate
 * templates in <head>. Highway still boots so main.js attach/detach/cache
 * callers do not throw.
 *
 * Remove this file + its theme.liquid tag to restore SPA routing.
 */
(function () {
    if (window.__ozarkeSpaClickBound) return;
    window.__ozarkeSpaClickBound = true;

    function hardNavigate(url) {
        if (!url) return;

        try {
            var next = new URL(url, window.location.href);
            if (next.href === window.location.href) {
                window.location.reload();
                return;
            }
            window.location.assign(next.href);
        } catch (err) {
            window.location.href = url;
        }
    }

    function linkFromEvent(event) {
        var node = event.target;
        if (!node) return null;
        if (node.closest) return node.closest("a[href]");
        while (node && node.nodeName !== "A") node = node.parentNode;
        return node && node.href ? node : null;
    }

    function shouldCapture(event) {
        if (event.button !== 0) return false;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;

        var link = linkFromEvent(event);
        if (!link) return false;
        if (link.hasAttribute("download")) return false;

        var target = link.getAttribute("target");
        if (target && target !== "_self") return false;

        var raw = link.getAttribute("href");
        if (!raw || raw.charAt(0) === "#") return false;

        var next;
        try {
            next = new URL(link.href, window.location.href);
        } catch (err) {
            return false;
        }

        if (next.protocol === "mailto:" || next.protocol === "tel:" || next.protocol === "javascript:") {
            return false;
        }

        if (next.origin !== window.location.origin) return false;

        // Same document + hash only: leave it (in-page jump / logo scroll).
        if (next.pathname === window.location.pathname && next.search === window.location.search) {
            return false;
        }

        // Search pager/chips handle their own query updates without a full reload.
        if (link.classList && link.classList.contains("ozarke-34-search-nav")) return false;
        if (link.closest && link.closest("[data-ozarke-34-pager]")) return false;

        return link;
    }

    // Capture runs before Highway's per-link bubble listeners. Stop those
    // listeners so they cannot preventDefault, then force a document load.
    document.addEventListener(
        "click",
        function (event) {
            var link = shouldCapture(event);
            if (!link) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            hardNavigate(link.href);
        },
        true
    );

    // Highway binds popState with .bind(this) in the constructor, so replacing
    // router.popState later does nothing. Reload on history back/forward.
    if (!window.__ozarkeSpaPopBound) {
        window.__ozarkeSpaPopBound = true;
        window.addEventListener("popstate", function () {
            window.location.reload();
        });
    }

    function patch(router) {
        if (!router || router.__ozarkeSpaDisabled) return true;

        router.__ozarkeSpaDisabled = true;
        router.fullDocumentNavigation = true;

        try {
            var attached = document.querySelectorAll("a:not([target]):not([data-router-disabled])");
            if (typeof router.detach === "function" && attached.length) {
                router.detach(attached);
            }
            if (typeof router.detach === "function" && router.links && router.links.length) {
                router.detach(router.links);
            }
        } catch (err) {}

        router.links = [];
        router.attach = function () {};
        router._navigate = function () {};
        router.navigate = function () {};

        router.redirect = function (url) {
            hardNavigate(url);
        };

        router.beforeFetch = function () {
            window.location.reload();
        };

        router.fetch = function () {
            return Promise.resolve("");
        };

        router.afterFetch = function () {
            return Promise.resolve();
        };

        if (router.running) hardNavigate(router.location && router.location.href);

        return true;
    }

    function tryPatch() {
        if (window.router && patch(window.router)) return;

        var attempts = 0;
        var id = setInterval(function () {
            attempts += 1;
            if (window.router && patch(window.router)) {
                clearInterval(id);
            } else if (attempts > 80) {
                clearInterval(id);
            }
        }, 50);
    }

    window.__ozarkeDisableSpa = patch;
    tryPatch();
})();
